<template>
  <div>
    <Nav className="navbar navbar-default navbar-mobile navbar-fixed bootsnav light" />
    <PicBanner :title="$t('jobs.title2')" :desc="$t('jobs.desc')" bgImg="/img/shutterstock_644430988.jpg" />
    <ApplicationList />
    <Footer :functions="meta.active_functions" />
    <FollowModal />
    <SubscribeModal />
  </div>
</template>

<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import PicBanner from '@/components/PicBanner.vue'
import ApplicationList from '@/components/ApplicationList.vue'
import Footer from '@/components/Footer.vue'
import FollowModal from '@/components/FollowModal.vue'
import SubscribeModal from '@/components/SubscribeModal.vue'

export default {
  name: 'jobs',
  props: ['meta'],
  data: function () {
    return {
    }
  },
  components: {
    Nav,
    PicBanner,
    ApplicationList,
    Footer,
    FollowModal,
    SubscribeModal
  },
  methods: {
    
  },
  created: function() {
    if (this.isMobile()) {
      //window.location = 'https://www.accacnjobs.com/#/app-history.html'
    }
  }
}
</script>
